import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RouterRoutes,
} from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// Pages
import HomePage from "pages/home";
import ServicesPage from "pages/services";
import OfflineMarketingPage from "pages/offline-marketing";
import TransformationsPage from "pages/transformations";
import BusiMagPage from "pages/busimag";
import BusiMagArticlePage from "pages/busimag/ArticlePage";
import PlatformPage from "pages/platform";
import PricingPage from "pages/pricing";
import StudioPage from "pages/studio";
import AboutPage from "pages/about";
import ContactPage from "pages/contact";
import ContactSuccessPage from "pages/contact/success.jsx";
import PrivacyPolicyPage from "pages/privacy";
import TermsPage from "pages/terms";
import AdminPortalRoot from "pages/ops/internal/contact-audit";
import AdminDashboardPage from "pages/ops/internal/contact-audit/pages/AdminDashboardPage";
import AdminExportsPage from "pages/ops/internal/contact-audit/pages/AdminExportsPage";
import AdminBlogsPage from "pages/ops/internal/contact-audit/pages/AdminBlogsPage";
import AdminPricingPage from "pages/ops/internal/contact-audit/pages/AdminPricingPage";
import AdminSettingsPage from "pages/ops/internal/contact-audit/pages/AdminSettingsPage";
import AdminSubmissionsPage from "pages/ops/internal/contact-audit/pages/AdminSubmissionsPage";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ErrorBoundary>
        <RouterRoutes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/offline-marketing" element={<OfflineMarketingPage />} />
          <Route path="/transformations" element={<TransformationsPage />} />
          <Route path="/busimag" element={<BusiMagPage />} />
          <Route path="/busimag/:slug" element={<BusiMagArticlePage />} />
          <Route path="/platform" element={<PlatformPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/studio" element={<StudioPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact/success" element={<ContactSuccessPage />} />
          <Route
            path="/internal/ops/portal/contact-audit-9x7k2"
            element={<AdminPortalRoot />}
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboardPage />} />
            <Route path="submissions" element={<AdminSubmissionsPage />} />
            <Route path="blogs" element={<AdminBlogsPage />} />
            <Route path="pricing" element={<AdminPricingPage />} />
            <Route path="exports" element={<AdminExportsPage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
          </Route>
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
